export default class MatchOptions {
    constructor() {
        this.blockSize = 0;
        this.repeatingWordsAccuracy = 0.0;
        this.ignoreWhitespaceDifferences = false;
    }
}